import { forwardRef, createElement } from 'react';

function IconSortBy(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M5.25 18a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm12.5-13.5a.75.75 0 01.743.648l.007.102v11.689l2.22-2.22a.75.75 0 011.133.977l-.073.084-3.5 3.5a.753.753 0 01-.125.101l-.088.049-.119.043-.106.021-.041.004-.07.002-.073-.006-.076-.013-.08-.023-.1-.043a.75.75 0 01-.182-.135l-3.5-3.5a.75.75 0 01.976-1.133l.084.073L17 16.939V5.25a.75.75 0 01.75-.75zm-9.5 9a.75.75 0 110 1.5h-5.5a.75.75 0 110-1.5h5.5zm3-4.5a.75.75 0 110 1.5h-8.5a.75.75 0 110-1.5h8.5zm3-4.5a.75.75 0 110 1.5H2.75a.75.75 0 010-1.5h11.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var SortBy = /*#__PURE__*/forwardRef(IconSortBy);

export default SortBy;
//# sourceMappingURL=SortBy.js.map
